export default __webpack_public_path__ + "static/media/logo-aftermath_research.f8be0723.svg";